export const theme = {
  CONSTANTS: {
    MAX_WIDTH: window.innerWidth,
    MAX_HEIGHT: window.innerHeight,
    XR: window.innerWidth / 667,
    XW: window.innerWidth / 100,
    XH: window.innerHeight / 100,
  },

  THEME: {
    black: "rgb(0, 0, 0)",
    white: "#FFFFFF",
    link: "#00AAFF",
    background: "#010917",
    grayText: "#F0F2FF",
    purple: "#A400FF",
    neonBlue: "#00AAFF",
    neonPink: "#FF01A2",
    purpleCiano:
      "linear-gradient(to right, #540B80, #107CA3, #6E03AA, #107CA3)",
    waveLine: "radial-gradient(circle, #000F2A 35%, #070063 59%)",
    base: "linear-gradient(90deg, #00D9FF, #2A75E5, #9235D9, #C23CA5, #D41A90, #00D9FF, #2A75E5, #9235D9, #D41A90)",
    error: "#FF4C4C",
    backgroundLight: "#1A1A1A",
  },
};
